import { CustomAutoComplete, CustomTextArea, DrawerFormSection } from '../../../common/components';
import { INTERNAL_DESTINATION_TEXTS as TEXTS } from '../constants/internalDestinationTexts';
import { AUTOCOMPLETE_LISTBOX_PROPS, drawerFieldSpan } from '../../../common/styles';
import { toProjectOptions } from '../../utils/toProjectOptions';
import { INTERNAL_MATERIAL_PURPOSES } from '../../constants/internalMaterialPurposes';
import {
  SUPPLY_DESTINATION_KINDS as KINDS,
} from '../../supply-orders/constants/supplyOrderDestinationConstants';

/** Destino de imputación separado de la ubicación física de recepción. */
const InternalOrderDestinationFields = ({ selectedOrder, destinations, onChange, projects }) => (
  <DrawerFormSection title={TEXTS.title} sx={{ mx: 0 }}>
    <CustomAutoComplete
      label={TEXTS.kind}
      name="destination_kind"
      value={selectedOrder.destination_kind || KINDS.PROJECT}
      options={TEXTS.kinds}
      onChange={onChange}
      sx={drawerFieldSpan(4)}
    />
    {selectedOrder.destination_kind === KINDS.INTERNAL ? (
      <>
        <CustomAutoComplete
          label={TEXTS.destination}
          name="uuid_operational_destination"
          value={selectedOrder.uuid_operational_destination || ''}
          options={destinations.map((row) => ({ value: row.uuid, label: row.name }))}
          inputPlaceholder={TEXTS.search}
          onChange={onChange}
          required
          sx={drawerFieldSpan(4)}
        />
        <CustomAutoComplete
          label={TEXTS.purpose}
          name="internal_purpose"
          value={selectedOrder.internal_purpose || ''}
          options={TEXTS.purposes}
          onChange={onChange}
          required
          sx={drawerFieldSpan(4)}
        />
        {selectedOrder.internal_purpose === INTERNAL_MATERIAL_PURPOSES.OTHER && (
          <CustomTextArea
            label={TEXTS.detail}
            name="internal_purpose_detail"
            value={selectedOrder.internal_purpose_detail || ''}
            onChange={onChange}
            required
            sx={drawerFieldSpan(12)}
          />
        )}
      </>
    ) : (
      <CustomAutoComplete
        label={TEXTS.project}
        name="uuid_project"
        value={selectedOrder.uuid_project || ''}
        options={toProjectOptions(projects)}
        inputPlaceholder={TEXTS.search}
        ListboxProps={AUTOCOMPLETE_LISTBOX_PROPS}
        onChange={onChange}
        required
        sx={drawerFieldSpan(8)}
      />
    )}
  </DrawerFormSection>
);
export default InternalOrderDestinationFields;
